import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'ffg',
});

export const unusedRoutesRouteRef = createSubRouteRef({
  id: 'ffg-unused-routes',
  parent: rootRouteRef,
  path: '/unused-routes',
});

export const sensitiveRoutesRouteRef = createSubRouteRef({
  id: 'ffg-sensitive-routes',
  parent: rootRouteRef,
  path: '/sensitive-routes',
});
